<template>
  <div>
    <div class="m-tabs-content">
      <el-row :gutter="24">
        <el-row>
          <el-col :span="5" class="tr m-label text_right">财税负责人</el-col>
          <el-col :span="17" :offset="1">
            <el-cascader
              style="width: 100%"
              v-model="addServer.leader_id"
              placeholder="请选择财税负责人"
              :options="users"
              size="mini"
              :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
              clearable
              filterable
              :filter-method="filterOptions"
            >
            </el-cascader>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5" class="tr m-label text_right">理票会计</el-col>
          <el-col :span="17" :offset="1">
            <el-cascader
              style="width: 100%"
              v-model="addServer.acc_id"
              placeholder="请选择理票会计"
              :options="users"
              size="mini"
              :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
              clearable
              filterable
              :filter-method="filterOptions"
            >
            </el-cascader>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5" class="tr m-label text_right">记账报税会计</el-col>
          <el-col :span="17" :offset="1">
            <el-cascader
              style="width: 100%"
              v-model="addServer.advisory_id"
              placeholder="请选择记账报税会计"
              :options="users"
              size="mini"
              :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
              clearable
              filterable
              :filter-method="filterOptions"
            >
            </el-cascader>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5" class="tr m-label text_right">客服会计</el-col>
          <el-col :span="17" :offset="1">
            <el-cascader
              style="width: 100%"
              v-model="addServer.ass_id"
              placeholder="请选择客服会计"
              :options="users"
              size="mini"
              :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
              clearable
              filterable
              :filter-method="filterOptions"
            >
            </el-cascader>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5" class="tr m-label text_right">综合会计</el-col>
          <el-col :span="17" :offset="1">
            <el-cascader
              style="width: 100%"
              v-model="addServer.general_accounting_id"
              placeholder="请选择综合会计"
              :options="users"
              size="mini"
              :props="{ expandTrigger: 'hover', multiple: true, emitPath: false }"
              clearable
              filterable
              :filter-method="filterOptions"
            >
            </el-cascader>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5" class="tr m-label text_right">开票会计</el-col>
          <el-col :span="17" :offset="1">
            <el-cascader
              style="width: 100%"
              v-model="addServer.invoice_id"
              placeholder="请选择开票会计"
              :options="users"
              size="mini"
              :props="{ expandTrigger: 'hover', emitPath: false, multiple: true }"
              clearable
              filterable
              :filter-method="filterOptions"
            >
            </el-cascader>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5" class="tr m-label text_right">财税顾问</el-col>
          <el-col :span="17" :offset="1">
            <el-cascader
              style="width: 100%"
              v-model="addServer.service_advisor_id"
              placeholder="请选择财税顾问"
              :options="users"
              size="mini"
              :props="{ expandTrigger: 'hover', emitPath: false , multiple: true}"
              clearable
              filterable
              :filter-method="filterOptions"
            >
            </el-cascader>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5" class="tr m-label text_right">共享人</el-col>
          <el-col :span="17" :offset="1">
            <el-cascader
              style="width: 100%"
              v-model="addServer.share_id"
              placeholder="请选择共享人"
              :options="users"
              size="mini"
              :props="{ expandTrigger: 'hover', multiple: true, emitPath: false }"
              clearable
              filterable
              :filter-method="filterOptions"
            >
            </el-cascader>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5" class="tr m-label text_right">企业税种</el-col>
          <el-col :span="17" :offset="1">
            <el-radio-group v-model="addServer.tax_types" size="mini">
              <el-radio label="2" border>小规模</el-radio>
              <el-radio label="3" border>一般纳税人</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5" class="tr m-label text_right">是否零申报</el-col>
          <el-col :span="17" :offset="1">
            <el-radio-group v-model="addServer.is_zero" size="mini">
              <el-radio :label="1" border>是</el-radio>
              <el-radio :label="2" border>否</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5" class="tr m-label text_right">记账软件</el-col>
          <el-col :span="17" :offset="1">
            <el-select
              :filterable="true"
              v-model="addServer.proxy_software"
              placeholder="记账软件"
              size="mini"
              clearable
            >
              <el-option :value="1" label="亿企赢(17DZ)">亿企赢(17DZ)</el-option>
              <el-option :value="2" label="云账房">云账房</el-option>
              <el-option :value="5" label="融易算">融易算</el-option>
              <el-option :value="3" label="易代账">易代账</el-option>
              <el-option :value="4" label="其他">其他</el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5" class="tr m-label text_right">开始时间</el-col>
          <el-col :span="17" :offset="1">
            <el-date-picker
              v-model="addServer.begin_time"
              type="month"
              size="mini"
              value-format="yyyy-MM"
            >
            </el-date-picker>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5" class="tr m-label text_right">服务时间</el-col>
          <el-col :span="17" :offset="1">
            <el-date-picker
              v-model="addServer.server_time"
              type="monthrange"
              size="mini"
              value-format="yyyy-MM"
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
              style="width: 70%"
            >
            </el-date-picker>
            &nbsp;&nbsp;(&nbsp;<el-checkbox
              @change="reSetGiftsLength"
              v-model="addServer.include_gifts"
              style="margin-left: 0.1rem"
              >是否包含赠送</el-checkbox
            >&nbsp;)
          </el-col>
        </el-row>
        <el-row v-if="addServer.include_gifts === true">
          <el-col :span="5" class="tr m-label text_right">赠送时长(月)</el-col>
          <el-col :span="17" :offset="1">
            <el-input
              v-model.trim="addServer.gifts_length"
              maxlength="3"
              placeholder="请输入赠送时长（月）"
              size="mini"
              clearable
            ></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5" class="tr m-label text_right">财务收费标准</el-col>
          <el-col :span="17" :offset="1">
            <el-input
              v-model="addServer.take_money_rule"
              placeholder="请输入财务收费标准（￥）"
              size="mini"
              clearable
            ></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5" class="tr m-label text_right">增值服务</el-col>
          <el-col :span="17" :offset="1">
            <!-- @click.native="getValueAdded" -->
            <el-select
              v-model="addServer.other_server"
              @change="changeOtherServer"
              multiple
              size="mini"
              placeholder="请选择增值服务 可多选"
            >
              <!-- <el-option v-for="item in pri_reg" :key="item.id" :label="item.sername" :value="item.id">
                </el-option> -->
              <el-option
                v-for="item in valueAddedOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5" class="tr m-label text_right">&nbsp;</el-col>
          <el-col :span="17" :offset="1">
            <table id="value-add-table">
              <tr v-for="item in SelectedValueAddedOptions" :key="item.id">
                <td>{{ item.name }}</td>
                <td>{{ item.type }}</td>
                <td>{{ item.price }}</td>
                <td>
                  <el-input
                    v-model="addServer.take_money_rule_real[item.id]"
                    placeholder="请输入实际价格（￥）"
                    size="mini"
                    clearable
                  ></el-input>
                </td>
              </tr>
            </table>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5" :offset="19">
            <el-button type="primary" @click="handleAddServerData" size="mini"
              >添加</el-button
            >
          </el-col>
        </el-row>
      </el-row>
    </div>
  </div>
</template>
<script>
import Chat from "common/Chat";
import WxWorkChat from "common/WxWorkChat";
import CallLogs from "common/CallLogs";
import OrderInfo from "common/OrderInfo";
import CompanyInfo from "common/CompanyInfo";
import EditInput from "./EditInput";
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';

export default {
  name: "ServiceEdit",
  props: {
    row: {
      type: Object,
    },
  },
  components: {
    Chat,
    WxWorkChat,
    CallLogs,
    CompanyInfo,
    OrderInfo,
    EditInput,
  },
  data() {
    return {
      other_server: [],
      editServerDrawer: false,
      SelectedValueAddedOptions: [],
      needPrice: "",
      needEditStatus: [],
      needCid: null,
      dialogFormVisibleResult: false,
      example_url: "",
      showExampleDialog: false,
      start_num_new: "",
      companyName_notRight_new: [],
      serviceEvent: false,
      serviceThings: false,
      serviceAccount: false,
      searchLoading: false,
      dialogFormVisible: false,
      endTime_notRight: [],
      companyName_notRight: [],
      start_num: "",
      end_num: "",
      dutiable: {
        taxpayer: null,
        provinces_code: null,
        city_code: null,
        area_code: null,
        my_electronic_password: null,
        login_way: "企业登录",
        login_identity: null,
        login_account: null,
        login_password: null,
        ca_password: null,
        natural_identity: null,
        natural_password: null,
        digital_certificate_password: null,
        digital_identity: "财务负责人",
        digital_account: null,
        digital_password: null,
        income_tax_way: "个税网报密码登录",
        income_tax_password: null,
        income_real_account: null,
        income_real_password: null,
        social_account: "社保网报密码登录",
        social_password: null,
        legal_name: null,
        finance_user: null,
      },
      flag: false,
      val: false,
      provincesArr: {},
      cityArr: {},
      areaArr: {},
      accountingReportFile: [],
      businessLicenseFile: [],
      businessCopyFile: [],
      bankOpenFile: [],
      limit: 10,
      headers: { Authorization: localStorage.token },
      addRelated: {
        company_id: null,
        pass_and_password: null,
        registration_password: null,
        electronic_password: null,
        wage_information: null,
        accounting_report: null,
        accounting_report_file_name: null,
        business_license_original: null,
        business_license_copy: null,
        bank_opening_permit: null,
      },
      tableRelated: {
        pass_and_password: null,
        registration_password: null,
        electronic_password: null,
        wage_information: null,
        accountingBuphoto: null,
        businessBuphoto: null,
        businessCopyBuphoto: null,
        bankOpenBuphoto: null,
      },
      tableData: [],
      toBottom: true,
      oldHeight: 0,
      addRoughly: "",
      addVisible: false,
      loading: false,
      editDrawer: false,
      chatDrawer: false,
      wxChatDrawer: false,
      continueDrawer: false,
      addServerDrawer: false,
      activeNames: [1],
      activeName: "first",
      orderItemName: "first",
      activeConName: "first",
      staffSaleryName: [1],
      inputSize: "mini",
      combos: [],
      items: [],
      users: [],
      areas: [],
      setField: [],
      tax_cates: [],
      itemRecord: [],
      header: [],
      records: [],
      finances: [],
      renewRecords: [],
      companies: [],
      orderNums: [],
      companys: [],
      pri_reg: [],
      tax_bureaus: [],
      market_bureaus: [],
      fin_tab_data: [],
      bussiness_content: [],
      companyId: null,
      chatCompany: "",
      chatId: "",
      companyName: "",
      wxWorkChatId: "",
      wxWorkchatCompany: "",
      searchArr: {
        end_time_null: "",
        start_time_null: "",
        company_id: "",
        start_time: "",
        end_time: "",
        finance_user: "",
        saler_id: "",
        leader_id: "",
        acc_id: "",
        ass_id: "",
        advisory_id: "",
        invoice_id: "",
        service_advisor_id: "",
        general_accounting_id: "",
        area_park: [],
        order_combo: "",
        is_ukey: "",
        is_invoice_bill: "",
        license_auth: "",
        triple_agreement: "",
        social_security: "",
        accumula_fund: "",
        manage_forms: "",
        server_status: "",
        // invoice_company: "",
        open_account: "",
        tax_scale: "",
        is_bind: "",
        is_subscribe: "",
        server_end: "",
        wx_work_bind: "",
        software_types: "",
        archives: "",
        provinces_code: "",
        city_code: "",
        area_code: "",
        login_way: "",
        taxNumber: "",
        my_electronic_password: "",
        login_identity: "",
        login_account: "",
        login_password: "",
        ca_password: "",
        natural_identity: "",
        natural_password: "",
        digital_certificate_password: "",
        digital_identity: "",
        digital_account: "",
        digital_password: "",
        income_tax_way: "",
        income_tax_password: "",
        income_real_account: "",
        income_real_password: "",
        social_account: "",
        social_password: "",
      },
      valueAddedOptions: [],
      addServer: {
        cid: null,
        leader_id: null,
        acc_id: null,
        ass_id: null,
        advisory_id: null,
        invoice_id: null,
        service_advisor_id: null,
        general_accounting_id: null,
        server_time: [],
        tax_types: "",
        take_money_rule: "",
        take_money_rule_real: [],
        other_server: "",
        begin_time: "",
        is_zero: "",
        share_id: null,
        proxy_software: "",
        include_gifts: false,
        gifts_length: "",
      },
      upData: {
        index: null,
        fid: null,
        company_id: "",
        company_name: "",
        start_time: null,
        end_time: null,
        legal_name: "",
        legal_phone: "",
        legal_id_number: "",
        tax_scale: "",
        check_tax_cate: [],
        area_park: [],
        tax_password: "",
        is_ukey: "",
        is_invoice_bill: "",
        open_account: "",
        // invoice_company: "",
        order_combo: "",
        order_item: [],
        license_auth: "",
        finance_buut_join: "",
        social_security: "",
        accumula_fund: "",
        triple_agreement: "",
        back_bill_card: "",
        manage_forms: "",
        server_status: "",
        invoice_seal: "",
        invoice_roughly: "",
        roughly_arr: [],
        other_remark: "",
        added_set: "",
        addtional_set: "",
        person_set: "",
        bussin_tax_set: "",
        company_set: "",
        stamp_set: "",
        house_set: "",
        finance_set: "",
        software_account: "",
        software_pass: "",
        advisory_account: "",
        advisory_pass: "",
        date_of_est: "",
        address_area: "",
        address_park: "",
        tax_over_name: "",
        tax_over_at: "",
        is_trust: null,
        is_buy_tax: "",
        tax_ctrl_type: "",
        filing_place: "",
        back_card_bank: "",
        back_card_number: "",
        back_card_pass: "",
        collect_type: "",
        tax_bureau: [],
        market_bureau: [],
        apply_type: [],
        debit_type: [],
        idcard_img: [],
        staffs: [],
        net_finance_person: null,
        is_zero_declare: 0,
      },
      fiscalData: {
        index: null,
        uid: null,
        uname: "",
        uphone: "",
        regtime: "",
        uedit: false,
        cid: null,
        cname: "",
        banks: [],
        start_time: "",
        end_time: "",
        order_nums: "",
        services: [],
        leader_id: null,
        leader_name: "",
        acc_id: null,
        acc_name: "",
        ass_id: null,
        ass_name: "",
        advisory_id: null,
        advisory_name: "",
        invoice_id: null,
        invoice_name: "",
        service_advisor_id: null,
        service_advisor_name: "",
        general_accounting_id: null,
        general_accounting_name: "",
        saler_id: null,
        saler_name: "",
        software_types: null,
        report: null,
        legaler: "",
        legaler_contact: "",
        taxNumber: "",
        operate_address: "",
        cre_code: "",
        trade: "",
        reg_cap: "",
        company_types: "",
        fromTime: "",
        toTime: "",
        bus_scope: "",
        isMicroEnt: "",
        invoice_payee: null,
        invoice_reviewer: null,
        invoice_drawer: null,
        invoice_common: null,
        invoice_ecommon: null,
        invoice_special: null,
        invoice_especial: null,
        invoice_common_rate: null,
        invoice_ecommon_rate: null,
        invoice_special_rate: null,
        invoice_especial_rate: null,
      },
      addBank: {
        cid: null,
        bank: "",
        accnumber: "",
        bank_type: "",
      },
      addChangeData: {
        remark: "",
        uid: "",
        bussin_content: [],
        company_id: "",
        urgency: 1,
      },
      suggestData: {
        id: null,
        company_id: "",
        start_time: "",
        end_time: "",
        suggest_content: "",
        current_combo: "",
        current_item: [],
      },
      renewData: {
        id: null,
        company_id: "",
        start_time: "",
        end_time: "",
        order_id: "",
      },
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        searchCurrentPage: 1, // 搜索后页码
        pageSize: 10, // 每页显示条数
      },
      itemPage: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      fields: [
        { id: "legal_name", name: "法定代表人" },
        { id: "legal_phone", name: "法人电话" },
        { id: "legal_id_number", name: "法人身份证" },
        { id: "finance_user", name: "财务负责人（网厅）" },
        { id: "tax_scale", name: "纳税规模" },
        { id: "server_status", name: "服务状态" },
        { id: "is_ukey", name: "购买UKEY" },
        { id: "is_invoice_bill", name: "购买发票" },
        // { id: "invoice_company", name: "开票单位" },
        { id: "finance_buut_join", name: "财税对接" },
        { id: "triple_agreement", name: "基本户信息表" },
        { id: "back_bill_card", name: "回单卡" },
        { id: "social_security", name: "社保" },
        { id: "accumula_fund", name: "公积金" },
        { id: "open_account", name: "CA开户" },
        { id: "leader", name: "财税负责人" },
        { id: "acc", name: "理票会计" },
        { id: "ass", name: "客服会计" },
        { id: "advisory", name: "记账报税会计" },
        { id: "invoice", name: "开票会计" },
        { id: "saler", name: "所属业务" },
        { id: "name", name: "用户姓名" },
        { id: "phone", name: "用户手机" },
        { id: "is_auth", name: "是否阅读须知" },
        { id: "subscribe", name: "是否关注公众号" },
      ],
      callLogsDrawer: false,
      company: "",
      callPhone: [],
      callPhone1: [],
      callPhone2: [],
      callPhone3: [],
      orderInfoVisible: false,
      orderInfoId: null,
      licenseList: [],
      formData: null,
      companyInfoDrawer: false,
      companyInfoId: null,
    };
  },
  created() {
    this.getFinanceSettingParams();
  },
  computed: {
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }
      return str;
    },
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === "development" ? "" : "https://weixin.qiyehuo.com";
      },
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    changeOtherServer(val) {
      this.addServer.take_money_rule_real.map((item, index) => {
        if (val.indexOf(index) === -1) {
          this.addServer.take_money_rule_real.splice(index);
        }
      });
    },
    reSetGiftsLength(val) {
      if (val === false) {
        this.addServer.gifts_length = "";
      }
    },
    doSomeThing(val) {
      console.log(val);
    },
    getValueAdded() {
      this.$axios
        .get("api/system_config_value_added_get_options")
        .then(({ data }) => {
          if (data.code === 200) {
            this.valueAddedOptions = data.data;
            this.handleOtherService();
          }
        })
        .catch();
    },
    // 复制功能
    copy(data) {
      // 存储传递过来的数据
      let OrderNumber = data;
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      let newInput = document.createElement("input");
      // 讲存储的数据赋值给input的value值
      newInput.value = OrderNumber;
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput);
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select();
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand("Copy");
      // 清空输入框
      newInput.remove();
      // 下面是element的弹窗 不需要的自行删除就好
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    copySome(data) {
      this.copy(data);
    },
    exportEndTime_notRight() {
      this.$axios
        .post(
          "api/finance/server_date_export_endtime",
          { endTime_notRight: this.endTime_notRight },
          { responseType: "blob" }
        )
        .then(({ data }) => {
          let blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let objectUrl = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.href = objectUrl;
          link.download = "服务到期时间不匹配.xlsx";
          link.click();
          setTimeout(function () {
            window.URL.revokeObjectURL(objectUrl);
          }, 10);
        })
        .catch();
    },
    exportCompanyName_notRight() {
      this.$axios
        .post(
          "api/finance/server_date_export",
          { companyName_notRight: this.companyName_notRight },
          { responseType: "blob" }
        )
        .then(({ data }) => {
          let blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let objectUrl = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.href = objectUrl;
          link.download = "公司名称不匹配.xlsx";
          link.click();
          setTimeout(function () {
            window.URL.revokeObjectURL(objectUrl);
          }, 10);
        })
        .catch();
    },
    closeAndClear() {
      this.endTime_notRight = [];
      this.companyName_notRight = [];
      this.start_num = "";
      this.end_num = "";
      this.dialogFormVisible = false;
      this.getFinanceData();
    },
    closeAndClearResult() {
      this.companyName_notRight_new = [];
      this.start_num_new = "";
      this.dialogFormVisibleResult = false;
      this.getFinanceData();
    },
    getInfo(res) {
      if (res.code === 1) {
        this.endTime_notRight = res.endTime_notRight;
        this.companyName_notRight = res.companyName_notRight;
        this.start_num = res.start_num;
        this.end_num = res.end_num;
        this.dialogFormVisible = true;
      }
    },
    handleCloseDialogFormVisibleResult(done) {
      this.closeAndClearResult();
      done();
    },
    upload(param) {
      const formData = new FormData();
      formData.append("file", param.file);
      this.$axios
        .post("api/finance/server_date_import", formData)
        .then(({ data }) => {
          if (data.code === 200) {
            this.start_num_new = data.data.num;
            this.companyName_notRight_new = data.data.not_exit_company;
            this.dialogFormVisibleResult = true;
          }
        })
        .catch((response) => {
          console.log("异常处理");
        });
    },
    toEdit(price, id) {
      this.needPrice = "";
      this.needCid = null;
      this.needEditStatus = [];
      this.needEditStatus.push(id);
      this.needEditStatus[id] = true;
      this.$nextTick(() => {
        this.needPrice = price;
        this.needCid = id;
      });
    },
    doUpdatePrice(price, company_id) {
      this.needEditStatus = [];
      this.finances.map((item) => {
        if (item.id === company_id) {
          item.com_fiscal_tax.fin_charges = price;
        }
      });
    },
    revert() {
      this.needEditStatus = [];
    },
    dutiableChange(val) {
      this.val = this.dutiable[val];
      this.$axios
        .get(
          "/api/admin/finance/dutiablechange?val=" +
            this.val +
            "&valname=" +
            val +
            "&company_id=" +
            this.upData.company_id
        )
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            this.getFinanceData();
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    addressarea(e) {
      this.dutiable.area_code = e;
      this.$axios
        .get(
          "/api/admin/finance/dutiablechangedq?provinces_code=" +
            this.dutiable.provinces_code +
            "&city_code=" +
            this.dutiable.city_code +
            "&area_code=" +
            this.dutiable.area_code +
            "&company_id=" +
            this.upData.company_id
        )
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    addresstowns(e) {
      this.dutiable.area_code = null;
      this.areaArr = {};
      this.$axios.get("/api/admin/policy/addresstowns?cityCode=" + e).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.areaArr = data.data.area;
        }
      });
    },
    addresscities(e) {
      this.dutiable.city_code = null;
      this.dutiable.area_code = null;
      this.cityArr = {};
      this.areaArr = {};
      this.areaArr = {};
      this.$axios
        .get("/api/admin/policy/addresscities?provincesCode=" + e)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.cityArr = data.data.city;
          }
        });
    },
    automaticUpdate(val, company) {
      if (val.label === "报税设置") {
        this.$axios
          .get(
            "/api/admin/finance/dutiableyijian?taxNumber=" +
              company.taxNumber +
              "&company_id=" +
              company.cid
          )
          .then((res) => {
            const { data } = res;
            if (data.code === 0) {
              // this.$message.success(data.msg)
              this.dutiable = data.data.dutiable;
              this.fiscalData.software_types = 1;
              this.cityArr = data.data.cityObj;
              this.getFinanceData();
            } else {
              this.$message.error(data.msg);
            }
          });
      }
    },
    handlerelatedStaff(company) {
      this.$axios
        .get(
          "/api/admin/finance/dutiableyijian?taxNumber=" +
            company.taxNumber +
            "&company_id=" +
            company.cid
        )
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            this.dutiable = data.data.dutiable;
            this.cityArr = data.data.cityObj;
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    copyOrderNums(orders) {
      let oInput = document.createElement("input");
      oInput.value = orders;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: "已成功复制到剪切板",
        type: "success",
      });
      oInput.remove();
    },
    getItemIds(items) {
      let item = [];
      if (items.length <= 0) {
        return item;
      }
      for (var i = 0; i < items.length; i++) {
        item.push(items[i].item_id);
      }
      return item;
    },
    getTaxCateIds(taxCates) {
      let tax = [];
      if (taxCates.length <= 0) {
        return tax;
      }
      for (var m = 0; m < taxCates.length; m++) {
        tax.push(taxCates[m].id);
      }
      return tax;
    },
    getServiceNames(services) {
      let service = [];
      if (services.length <= 0) {
        return service;
      }
      for (var j = 0; j < services.length; j++) {
        service.push(services[j].sername);
      }
      return service;
    },
    getFinanceData() {
      this.$axios
        .get(
          "/api/finance?page=" +
            this.pageOption.currentPage +
            "&limit=" +
            this.pageOption.pageSize +
            this.searchStr
        )
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.finances = data.data.list.data;
            this.header = data.data.header;
            this.pageOption.total = data.data.list.total;
            this.pageOption.currentPage = data.data.list.current_page;

            // this.provincesArr = data.data.provinces
            // this.combos = data.data.combos
            // this.tax_cates = data.data.tax_cates
            // this.items = data.data.items
            // this.users = data.data.users
            // this.areas = data.data.areas
            // this.bussiness_content = data.data.bussiness_content
            // this.tax_bureaus = data.data.tax_bureau
            // this.market_bureaus = data.data.market_bureau
            // this.pri_reg = data.data.pri_reg

            // this.setField = []
            // if (data.data.fields && data.data.fields.length > 0) {
            //     this.setField = data.data.fields
            // } else {
            //     for (let k = 0; k < this.fields.length; k++) {
            //         this.setField.push(this.fields[k].id)
            //     }
            // }
          }
        });
    },

    getFinanceSettingParams() {
      this.$axios.get("/api/finance/setting/get_setting_params").then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.provincesArr = data.data.provinces;
          this.combos = data.data.combos;
          this.tax_cates = data.data.tax_cates;
          this.items = data.data.items;
          this.users = data.data.users;
          this.areas = data.data.areas;
          this.bussiness_content = data.data.bussiness_content;
          this.tax_bureaus = data.data.tax_bureau;
          this.market_bureaus = data.data.market_bureau;
          this.pri_reg = data.data.pri_reg;
          this.setField = [];
          if (data.data.fields && data.data.fields.length > 0) {
            this.setField = data.data.fields;
          } else {
            for (let k = 0; k < this.fields.length; k++) {
              this.setField.push(this.fields[k].id);
            }
          }
        }
      });
    },

    getFinanceRecords(fid, id) {
      this.$axios.get("/api/finance/records/" + fid + "?cid=" + id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.records = data.data.records;
          this.companys = data.data.companys;
        }
      });
    },
    getItemsData(cid) {
      this.$axios
        .get("/api/finance/items/" + cid + "?page=" + this.itemPage.currentPage)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.itemRecord = data.data.items.data;
            this.itemPage.total = data.data.items.total;
            this.itemPage.currentPage = data.data.items.current_page;
            this.provincesArr = data.data.provinces;
            this.cityArr = data.data.cityArr;
            this.areaArr = data.data.areaArr;
            if (data.data.dutiable === null) {
              this.dutiable.taxpayer = null;
              this.dutiable.provinces_code = null;
              this.dutiable.city_code = null;
              this.dutiable.area_code = null;
              this.dutiable.my_electronic_password = null;
              this.dutiable.login_way = "企业登录";
              this.dutiable.login_identity = null;
              this.dutiable.login_account = null;
              this.dutiable.login_password = null;
              this.dutiable.ca_password = null;
              this.dutiable.natural_identity = null;
              this.dutiable.natural_password = null;
              this.dutiable.digital_certificate_password = null;
              this.dutiable.digital_identity = "财务负责人";
              this.dutiable.digital_account = null;
              this.dutiable.digital_password = null;
              this.dutiable.income_tax_way = "个税网报密码登录";
              this.dutiable.income_tax_password = null;
              this.dutiable.income_real_account = null;
              this.dutiable.income_real_password = null;
              this.dutiable.social_account = "社保网报密码登录";
              this.dutiable.social_password = null;
              this.dutiable.legal_name = null;
              this.dutiable.finance_user = null;
            } else {
              this.dutiable = data.data.dutiable;
            }
          }
        });
    },
    saveInvoiceChange(field) {
      this.$axios
        .post("/api/finance/com_invoice/" + this.fiscalData.cid, {
          field: field,
          value: this.fiscalData[field],
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    SaveChangeMethods(field, fieldName) {
      let oldValue = null;
      if (field === "order_item") {
        oldValue = this.getItemIds(this.finances[this.upData.index].fin_table.item_types);
      } else if (field === "check_tax_cate") {
        oldValue = this.getTaxCateIds(
          this.finances[this.upData.index].fin_table.check_tax_cate_name
        );
      } else if (field === "start_time") {
        if (this.upData.start_time >= this.upData.end_time) {
          this.$message.error("服务到期时间不能小于服务开始时间");
          return false;
        }
      } else if (field === "end_time") {
        var startTimeValue = this.upData.start_time;
        if (!this.upData.start_time) {
          this.$message.error("请先选择服务开始时间");
          return false;
        }
        if (this.upData.start_time >= this.upData.end_time) {
          this.$message.error("服务到期时间不能小于服务开始时间");
          return false;
        }
      } else {
        oldValue = this.finances[this.upData.index].fin_table[field];
      }
      this.$axios
        .put("/api/finance/" + this.upData.fid, {
          fieldName: field,
          value: this.upData[field],
          old: oldValue,
          typeName: fieldName,
          startTimeValue: field === "end_time" ? startTimeValue : "",
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.records.unshift(data.data.record);
            this.finances[this.upData.index].fin_table = data.data.finance_table;
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    changeFinanceUser(filed) {
      this.$axios
        .post("/api/finance/change_fin/" + this.fiscalData.cid, {
          filed: filed,
          value: this.fiscalData[filed],
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            if (data.data) {
              this.records.unshift(data.data);
              if (filed === "saler_id") {
                this.finances[this.fiscalData.index].saler_id = this.fiscalData[filed];
              } else {
                this.finances[this.fiscalData.index].com_fiscal_tax[
                  filed
                ] = this.fiscalData[filed];
              }
            }
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleColChange() {
      this.$axios.post("/api/finance/set_field", this.setField).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.$message.success(data.msg);
        }
      });
    },
    handleAddChangeSave() {
      if (!this.addChangeData.bussin_content) {
        this.$message.error("商机内容不能为空");
        return;
      }
      if (!this.addChangeData.urgency) {
        this.$message.error("商机紧急程度不能为空");
        return;
      }
      this.$axios.post("/api/bussin_change", this.addChangeData).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.$message.success(data.msg);
          this.clearChangeSuggest();
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleAddSuggestSave() {
      if (!this.suggestData.start_time) {
        this.$message.error("开始时间不能为空");
        return;
      }
      if (!this.suggestData.end_time) {
        this.$message.error("到期时间不能为空");
        return;
      }
      if (!this.suggestData.suggest_content) {
        this.$message.error("建议内容不能为空");
        return;
      }
      this.$axios.post("/api/finance/add_sug", this.suggestData).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.$message.success(data.msg);
          this.clearChangeSuggest();
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleAddRenewSave() {
      if (!this.renewData.order_id) {
        this.$message.error("订单不能为空");
        return;
      }
      if (!this.renewData.start_time) {
        this.$message.error("服务开始时间不能为空");
        return;
      }
      if (!this.renewData.end_time) {
        this.$message.error("服务到期时间不能为空");
        return;
      }
      this.$axios
        .put("/api/finance/renews_add/" + this.renewData.id, this.renewData)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.clearChangeSuggest();
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleAddBank() {
      if (!this.addBank.bank) {
        this.$message.error("开户银行不能为空");
        return;
      }
      if (!this.addBank.accnumber) {
        this.$message.error("开户行账户不能为空");
        return;
      }
      if (!this.addBank.bank_type) {
        this.$message.error("账户类型不能为空");
        return;
      }
      this.$axios.post("/api/finance/add_bank", this.addBank).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.fiscalData.banks.push(data.data);
          this.addBank.bank = "";
          this.addBank.accnumber = "";
          this.addBank.bank_type = "";
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    getRenewOpeates(companyId) {
      this.$axios.get("/api/finance/renews_records/" + companyId).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.renewRecords = data.data;
        }
      });
    },
    handleContinueOpen(index, row) {
      this.clearChangeData();
      this.addChangeData.company_id = row.id;
      this.suggestData.company_id = row.id;
      this.renewData.company_id = row.id;
      this.companyName = row.company_name;
      this.getRenewOpeates(row.id);
      if (!row.fin_table) {
        this.$axios.get("/api/finance/fin_table/" + row.id).then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.suggestData.id = data.data.fin_table.id;
            this.renewData.id = data.data.fin_table.id;
            this.finances[index].fin_table = data.data.fin_table;
          }
        });
      } else {
        this.suggestData.id = row.fin_table.id;
        this.renewData.id = row.fin_table.id;
      }
      this.continueDrawer = true;
    },
    handleChatOpen(chat, companyName) {
      if (chat) {
        this.chatDrawer = true;
        setTimeout(() => {
          this.chatId = chat.chat_id;
          this.chatCompany = companyName;
        });
      }
    },
    handleWxChatOpen(chat, companyName) {
      if (chat) {
        this.wxChatDrawer = true;
        setTimeout(() => {
          this.wxWorkChatId = chat.chat_id;
          this.wxWorkchatCompany = companyName;
        });
      }
    },
    handleWxChatBeforeClose(done) {
      this.wxWorkChatId = "";
      this.wxWorkchatCompany = "";
      done();
    },
    handleEditBeforeClose(done) {
      this.clearEditDatas();
      done();
    },
    handleChatBeforeClose(done) {
      this.clearChatsData();
      done();
    },
    handleGetSearchData() {
      this.pageOption.currentPage = 1;
      this.getFinanceData();
    },
    handleClearSearchData() {
      this.clearSearchDatas();
      this.getFinanceData();
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.getFinanceData();
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.getFinanceData();
    },
    handleItemCurrentChange(val) {
      this.itemPage.currentPage = val;
      this.getItemsData(this.fiscalData.cid);
    },
    handleCompanyChange() {
      this.pageOption.currentPage = 1;
      this.getFinanceData();
    },
    handleBindUser() {
      if (!this.fiscalData.uid) {
        this.$message.error("请填写要绑定客户的id");
        return;
      }
      this.$axios
        .post("/api/finance/user_id/" + this.fiscalData.cid + "/" + this.fiscalData.uid)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.fiscalData.uid = data.data.user.id;
            this.fiscalData.uname = data.data.user.name;
            this.fiscalData.uphone = data.data.user.phone;
            this.fiscalData.uedit = true;
            this.finances[this.fiscalData.index].user = data.data.user;
          }
        });
    },
    getEditDataByCompany(index, cid) {
      this.$axios.get("/api/finance/fin_table/" + cid).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.upData.fid = data.data.fin_table.id;
          this.upData.start_time = data.data.fin_table.start_time;
          this.upData.end_time = data.data.fin_table.end_time;
          this.upData.legal_name = data.data.fin_table.legal_name;
          this.upData.legal_phone = data.data.fin_table.legal_phone;
          this.upData.legal_id_number = data.data.fin_table.legal_id_number;
          this.upData.tax_scale = data.data.fin_table.tax_scale;
          this.upData.area_park = data.data.fin_table.area_park
            ? data.data.fin_table.area_park
            : [];
          this.upData.tax_bureau = data.data.fin_table.tax_bureau
            ? data.data.fin_table.tax_bureau
            : [];
          this.upData.market_bureau = data.data.fin_table.market_bureau
            ? data.data.fin_table.market_bureau
            : [];
          this.upData.apply_type = data.data.fin_table.apply_type
            ? data.data.fin_table.apply_type
            : [];
          this.upData.debit_type = data.data.fin_table.debit_type
            ? data.data.fin_table.debit_type
            : [];
          this.upData.tax_password = data.data.fin_table.tax_password;
          this.upData.is_ukey = data.data.fin_table.is_ukey;
          this.upData.is_invoice_bill = data.data.fin_table.is_invoice_bill;
          this.upData.open_account = data.data.fin_table.open_account;
          // this.upData.invoice_company = data.data.fin_table.invoice_company;
          this.upData.order_combo = data.data.fin_table.order_combo;
          this.upData.order_item = this.getItemIds(data.data.fin_table.item_types);
          this.upData.license_auth = data.data.fin_table.license_auth;
          this.upData.finance_buut_join = data.data.fin_table.finance_buut_join;
          this.upData.social_security = data.data.fin_table.social_security;
          this.upData.accumula_fund = data.data.fin_table.accumula_fund;
          this.upData.triple_agreement = data.data.fin_table.triple_agreement;
          this.upData.back_bill_card = data.data.fin_table.back_bill_card;
          this.upData.manage_forms = data.data.fin_table.manage_forms;
          this.upData.server_status = data.data.fin_table.server_status;
          this.upData.invoice_seal = data.data.fin_table.invoice_seal;
          this.upData.other_remark = data.data.fin_table.other_remark;
          this.upData.is_zero_declare = data.data.fin_table.is_zero_declare;
          this.finances[index].fin_table = data.data.fin_table;
          this.getFinanceRecords(data.data.fin_table.id, data.data.id);
        }
      });
    },
    handleAddServer(index, row) {
      this.addServerDrawer = true;
      this.addServer.index = index;
      this.addServer.cid = row.id;
    },
    handleEditServer(index, row) {
      this.editServerDrawer = true;
      // this.addServer.index = index
      // this.addServer.cid = row.id
    },
    handleAddServerData() {
      // if (!this.addServer.leader_id) {
      //   this.$message.error('请选择财税负责人')
      //   return
      // }
      // if (!this.addServer.acc_id) {
      //   this.$message.error('请选择理票会计')
      //   return
      // }
      // if (!this.addServer.advisory_id) {
      //   this.$message.error('请选择记账报税会计')
      //   return
      // }
      // if (!this.addServer.ass_id) {
      //   this.$message.error('请选择客服会计')
      //   return
      // }
      // if (!this.addServer.invoice_id) {
      //   this.$message.error('请选择开票会计')
      //   return
      // }
      // if (!this.addServer.server_time.length) {
      //   this.$message.error('请选择服务时间')
      //   return
      // }
      // if (!this.addServer.take_money_rule) {
      //   this.$message.error('请输入财务收费标准')
      //   return
      // }
      // if (!this.addServer.tax_type) {
      //   this.$message.error('请选择企业税种')
      //   return
      // }
      // if (!this.addServer.other_server.length) {
      //   this.$message.error('请选择服务内容')
      //   return
      // }
      if (this.addServer.take_money_rule) {
        var reg = /^-?\d{1,8}(?:\.\d{1,2})?$/; // 小数点左边最高4位，小数点右边最多4位
        if (!reg.test(this.addServer.take_money_rule)) {
          this.$message.warning("请输入正确的数字,小数点后可1到2位");
          return false;
        }
      }
      // this.addServer.take_money_rule_real.map(item => {
      //     if (item) {
      //         var reg = /^-?\d{1,8}(?:\.\d{1,2})?$/ // 小数点左边最高4位，小数点右边最多4位
      //         if (!reg.test(item)) {
      //             this.$message.warning('请在增值服务中输入正确的数字,小数点后可1到2位')
      //             return false
      //         }
      //     }
      // })
      if (this.addServer.other_server.length > 0) {
        for (var i = 0; i < this.addServer.other_server.length; i++) {
          if (!this.addServer.take_money_rule_real[this.addServer.other_server[i]]) {
            return this.$message.warning("增值服务实际价格必须填写!");
          }
        }
        try {
          this.addServer.take_money_rule_real.map((item) => {
            if (item) {
              var reg = /^-?\d{1,8}(?:\.\d{1,2})?$/; // 小数点左边最高4位，小数点右边最多4位
              if (!reg.test(item)) {
                this.$message.warning("请在增值服务中输入正确的数字,小数点后可1到2位");
                throw new Error();
              }
            }
          });
        } catch (err) {
          return false;
        }
      }
      if (this.addServer.include_gifts) {
        if (this.addServer.gifts_length) {
          var numReg = /^[0-9]*$/;
          var numRe = new RegExp(numReg);
          if (!numRe.test(this.addServer.gifts_length)) {
            return this.$message.warning("赠送时长请输入数字！");
          }
        } else {
          return this.$message.warning("赠送时长没有填写！");
        }
      }
      this.changeOtherServer(this.addServer.other_server);
      this.$axios.put("/api/finance/edit_server", this.addServer).then((res) => {
        const { data } = res;
        if (data.code === 200) {
          // this.finances[this.addServer.index].com_fiscal_tax =
          //     data.data.fiscal_tax
          // this.clearAddServerData()
          // this.addServerDrawer = false
          // this.getFinanceData()
          this.$message.success(data.msg);
          this.$emit("closeEditDrawer");
        }
      });
    },
    //   handleEditFinance(index, row) {
    //     this.accountingReportFile = []
    //     this.businessLicenseFile = []
    //     this.businessCopyFile = []
    //     this.bankOpenFile = []
    //     this.addRelated.company_id = row.company_id
    //     this.addRelated.pass_and_password = row.pass_and_password
    //     this.addRelated.registration_password = row.registration_password
    //     this.addRelated.electronic_password = row.electronic_password
    //     this.addRelated.wage_information = row.wage_information
    //     this.upData.index = index
    //     this.upData.company_id = row.id
    //     this.upData.company_name = row.company_name
    //     this.upData.date_of_est = row.date_of_est
    //     this.upData.address_area = row.address_area
    //     this.upData.address_park = row.address_park
    //     if (!row.fin_table) {
    //       this.getEditDataByCompany(index, row.id)
    //     } else {
    //       this.upData.fid = row.fin_table.id
    //       this.upData.start_time = row.fin_table.start_time
    //       this.upData.end_time = row.fin_table.end_time
    //       this.upData.legal_name = row.fin_table.legal_name
    //       this.upData.legal_phone = row.fin_table.legal_phone
    //       this.upData.legal_id_number = row.fin_table.legal_id_number
    //       this.upData.tax_scale = row.fin_table.tax_scale
    //       this.upData.check_tax_cate = this.getTaxCateIds(
    //         row.fin_table.check_tax_cate_name
    //       )
    //       this.upData.area_park = row.fin_table.area_park
    //         ? row.fin_table.area_park
    //         : []
    //       this.upData.tax_bureau = row.fin_table.tax_bureau
    //         ? row.fin_table.tax_bureau
    //         : []
    //       this.upData.market_bureau = row.fin_table.market_bureau
    //         ? row.fin_table.market_bureau
    //         : []
    //       this.upData.tax_password = row.fin_table.tax_password
    //       this.upData.is_ukey = row.fin_table.is_ukey
    //       this.upData.is_invoice_bill = row.fin_table.is_invoice_bill
    //       this.upData.open_account = row.fin_table.open_account
    //       this.upData.invoice_company = row.fin_table.invoice_company
    //       this.upData.order_combo = row.fin_table.order_combo
    //       this.upData.order_item = this.getItemIds(row.fin_table.item_types)
    //       this.upData.license_auth = row.fin_table.license_auth
    //       this.upData.finance_buut_join = row.fin_table.finance_buut_join
    //       this.upData.social_security = row.fin_table.social_security
    //       this.upData.accumula_fund = row.fin_table.accumula_fund
    //       this.upData.triple_agreement = row.fin_table.triple_agreement
    //       this.upData.back_bill_card = row.fin_table.back_bill_card
    //       this.upData.manage_forms = row.fin_table.manage_forms
    //       this.upData.server_status = row.fin_table.server_status
    //       this.upData.invoice_seal = row.fin_table.invoice_seal
    //       this.upData.invoice_roughly =
    //         row.fin_table.fin_roughly.length > 0
    //           ? row.fin_table.fin_roughly[0].invoice_roughly
    //           : ''
    //       this.upData.roughly_arr =
    //         row.fin_table.fin_roughly.length > 0 ? row.fin_table.fin_roughly : []
    //       this.upData.other_remark = row.fin_table.other_remark
    //       this.upData.idcard_img = row.fin_table.idcard_img
    //       this.upData.tax_over_name = row.fin_table.tax_over_name
    //         ? row.fin_table.tax_over_name
    //         : ''
    //       this.upData.tax_over_at = row.fin_table.tax_over_at
    //         ? row.fin_table.tax_over_at
    //         : ''
    //       this.upData.apply_type = row.fin_table.apply_type
    //         ? row.fin_table.apply_type
    //         : []
    //       this.upData.debit_type = row.fin_table.debit_type
    //         ? row.fin_table.debit_type
    //         : []
    //       this.fiscalData.start_time = row.fin_table.start_time
    //         ? row.fin_table.start_time
    //         : ''
    //       this.fiscalData.end_time = row.fin_table.end_time
    //         ? row.fin_table.end_time
    //         : ''
    //       this.upData.software_account = row.fin_table.software_account
    //         ? row.fin_table.software_account
    //         : ''
    //       this.upData.software_pass = row.fin_table.software_pass
    //         ? row.fin_table.software_pass
    //         : ''
    //       this.upData.advisory_account = row.fin_table.advisory_account
    //         ? row.fin_table.advisory_account
    //         : ''
    //       this.upData.advisory_pass = row.fin_table.advisory_pass
    //         ? row.fin_table.advisory_pass
    //         : ''
    //       this.upData.back_card_bank = row.fin_table.back_card_bank
    //         ? row.fin_table.back_card_bank
    //         : ''
    //       this.upData.back_card_number = row.fin_table.back_card_number
    //         ? row.fin_table.back_card_number
    //         : ''
    //       this.upData.back_card_pass = row.fin_table.back_card_pass
    //         ? row.fin_table.back_card_pass
    //         : ''
    //       this.upData.collect_type = row.fin_table.collect_type
    //         ? row.fin_table.collect_type
    //         : ''
    //       this.upData.is_trust = row.fin_table.is_trust
    //       this.upData.is_buy_tax = row.fin_table.is_buy_tax
    //       this.upData.is_tax_ctrl_typetrust = row.fin_table.tax_ctrl_type
    //       this.upData.filing_place = row.fin_table.filing_place
    //       this.upData.net_finance_person = row.fin_table.net_finance_person
    //       this.upData.is_zero_declare = row.fin_table.is_zero_declare
    //       this.getFinanceRecords(row.fin_table.id, row.id)
    //     }
    //     if (row.tax_payment) {
    //       this.upData.added_set = row.tax_payment.added_set
    //       this.upData.addtional_set = row.tax_payment.addtional_set
    //       this.upData.person_set = row.tax_payment.person_set
    //       this.upData.bussin_tax_set = row.tax_payment.bussin_tax_set
    //       this.upData.company_set = row.tax_payment.company_set
    //       this.upData.stamp_set = row.tax_payment.stamp_set
    //       this.upData.house_set = row.tax_payment.house_set
    //       this.upData.finance_set = row.tax_payment.finance_set
    //     }
    //     if (row.staffs.length) {
    //       this.upData.staffs = row.staffs
    //     }
    //     if (row.user) {
    //       this.fiscalData.uid = row.user.id
    //       this.fiscalData.uname = row.user.name
    //       this.fiscalData.uphone = row.user.phone
    //       this.fiscalData.regtime = row.user.regtime
    //       this.fiscalData.uedit = true
    //     }
    //     this.fiscalData.index = index
    //     this.fiscalData.cid = row.id
    //     this.fiscalData.cname = row.company_name
    //     this.fiscalData.legaler = row.legaler
    //     this.fiscalData.legaler_contact = row.legaler_contact
    //     this.fiscalData.taxNumber = row.taxNumber
    //     this.fiscalData.operate_address = row.operate_address
    //     this.fiscalData.saler_id = row.saler_id
    //     this.fiscalData.saler_name = row.salers ? row.salers.username : ''
    //     this.fiscalData.invoice_payee = row.invoice_payee
    //     this.fiscalData.invoice_reviewer = row.invoice_reviewer
    //     this.fiscalData.invoice_drawer = row.invoice_drawer
    //     this.fiscalData.invoice_common = row.invoice_common
    //     this.fiscalData.invoice_ecommon = row.invoice_ecommon
    //     this.fiscalData.invoice_special = row.invoice_special
    //     this.fiscalData.invoice_especial = row.invoice_especial
    //     this.fiscalData.invoice_drawer = row.invoice_drawer
    //     this.fiscalData.invoice_common_rate = row.invoice_common_rate
    //     this.fiscalData.invoice_ecommon_rate = row.invoice_ecommon_rate
    //     this.fiscalData.invoice_special_rate = row.invoice_special_rate
    //     this.fiscalData.invoice_especial_rate = row.invoice_especial_rate
    //     this.fiscalData.cre_code = row.cre_code
    //     this.fiscalData.trade = row.trade
    //     this.fiscalData.reg_cap = row.reg_cap
    //     this.fiscalData.company_types = row.company_types
    //     this.fiscalData.fromTime = row.fromTime
    //     this.fiscalData.toTime = row.toTime
    //     this.fiscalData.bus_scope = row.bus_scope
    //     this.fiscalData.isMicroEnt = row.isMicroEnt
    //     this.addBank.cid = row.id
    //     if (row.com_fiscal_tax) {
    //       this.fiscalData.leader_id = row.com_fiscal_tax.leader_id
    //         ? row.com_fiscal_tax.leader_id
    //         : null
    //       this.fiscalData.ass_id = row.com_fiscal_tax.ass_id
    //         ? row.com_fiscal_tax.ass_id
    //         : null
    //       this.fiscalData.acc_id = row.com_fiscal_tax.acc_id
    //         ? row.com_fiscal_tax.acc_id
    //         : null
    //       this.fiscalData.advisory_id = row.com_fiscal_tax.advisory_id
    //         ? row.com_fiscal_tax.advisory_id
    //         : null
    //       this.fiscalData.invoice_id = row.com_fiscal_tax.invoice_id
    //         ? row.com_fiscal_tax.invoice_id
    //         : null
    //       this.fiscalData.leader_name = row.com_fiscal_tax.leader
    //         ? row.com_fiscal_tax.leader.username
    //         : ''
    //       this.fiscalData.acc_name = row.com_fiscal_tax.acc
    //         ? row.com_fiscal_tax.acc.username
    //         : ''
    //       this.fiscalData.ass_name = row.com_fiscal_tax.ass
    //         ? row.com_fiscal_tax.ass.username
    //         : ''
    //       this.fiscalData.advisory_name = row.com_fiscal_tax.advisory
    //         ? row.com_fiscal_tax.advisory.username
    //         : ''
    //       this.fiscalData.invoice_name = row.com_fiscal_tax.invoice
    //         ? row.com_fiscal_tax.invoice.username
    //         : ''
    //       this.fiscalData.software_types = row.com_fiscal_tax.software_types
    //         ? row.com_fiscal_tax.software_types
    //         : null
    //       this.fiscalData.report = row.com_fiscal_tax.report
    //         ? row.com_fiscal_tax.report
    //         : null
    //     }
    //     this.fiscalData.services = this.getServiceNames(row.services)
    //     this.fiscalData.order_nums = row.tyc_orders
    //     this.fiscalData.banks = row.banks ? row.banks : []
    //     this.getItemsData(row.id)
    //     this.editDrawer = true
    //   },
    handleConBeforeClose() {
      this.companyName = "";
      this.clearChangeSuggest();
    },
    clearEditDatas() {
      this.upData.company_id = "";
      this.upData.company_name = "";
      this.upData.start_time = "";
      this.upData.end_time = "";
      this.upData.legal_name = "";
      this.upData.legal_phone = "";
      this.upData.legal_id_number = "";
      this.upData.tax_scale = "";
      this.upData.check_tax_cate = [];
      this.upData.area_park = [];
      this.upData.tax_password = "";
      this.upData.is_ukey = "";
      this.upData.is_invoice_bill = "";
      this.upData.open_account = "";
      // this.upData.invoice_company = "";
      this.upData.order_combo = "";
      this.upData.order_item = [];
      this.upData.license_auth = "";
      this.upData.finance_buut_join = "";
      this.upData.social_security = "";
      this.upData.accumula_fund = "";
      this.upData.triple_agreement = "";
      this.upData.back_bill_card = "";
      this.upData.manage_forms = "";
      this.upData.server_status = "";
      this.upData.other_remark = "";
      this.upData.invoice_seal = "";
      this.upData.invoice_roughly = "";
      this.upData.roughly_arr = [];
      this.upData.index = null;
      this.upData.fid = null;
      this.upData.added_set = "";
      this.upData.addtional_set = "";
      this.upData.person_set = "";
      this.upData.bussin_tax_set = "";
      this.upData.company_set = "";
      this.upData.stamp_set = "";
      this.upData.house_set = "";
      this.upData.finance_set = "";
      this.upData.software_account = "";
      this.upData.software_pass = "";
      this.upData.advisory_account = "";
      this.upData.advisory_pass = "";
      this.upData.date_of_est = "";
      this.upData.address_area = "";
      this.upData.address_park = "";
      this.upData.tax_bureau = [];
      this.upData.market_bureau = [];
      this.upData.staffs = [];
      this.upData.apply_type = [];
      this.upData.debit_type = [];
      this.upData.idcard_img = [];
      this.upData.tax_over_name = "";
      this.upData.tax_over_at = "";
      this.upData.is_trust = null;
      this.upData.is_buy_tax = "";
      this.upData.tax_ctrl_type = "";
      this.upData.filing_place = "";
      this.upData.back_card_bank = "";
      this.upData.back_card_number = "";
      this.upData.back_card_pass = "";
      this.upData.collect_type = "";
      this.upData.net_finance_person = null;
      this.upData.is_zero_declare = 0;
      this.fiscalData.cid = null;
      this.fiscalData.banks = [];
      this.fiscalData.order_nums = [];
      this.fiscalData.services = [];
      this.fiscalData.leader_id = null;
      this.fiscalData.acc_id = null;
      this.fiscalData.ass_id = null;
      this.fiscalData.advisory_id = null;
      this.fiscalData.invoice_id = null;
      this.fiscalData.service_advisor_id = null;
      this.fiscalData.general_accounting_id = null;
      this.fiscalData.saler_id = null;
      this.fiscalData.software_types = null;
      this.fiscalData.report = null;
      this.fiscalData.saler_name = "";
      this.fiscalData.leader_name = "";
      this.fiscalData.ass_name = "";
      this.fiscalData.acc_name = "";
      this.fiscalData.advisory_name = "";
      this.fiscalData.invoice_name = "";
      this.fiscalData.cname = "";
      this.fiscalData.legaler = "";
      this.fiscalData.legaler_contact = "";
      this.fiscalData.taxNumber = "";
      this.fiscalData.operate_address = "";
      this.fiscalData.invoice_payee = null;
      this.fiscalData.invoice_reviewer = null;
      this.fiscalData.invoice_drawer = null;
      this.fiscalData.uid = null;
      this.fiscalData.uname = "";
      this.fiscalData.uphone = "";
      this.fiscalData.regtime = "";
      this.fiscalData.uedit = false;
      this.fiscalData.index = null;
      this.fiscalData.invoice_common = null;
      this.fiscalData.invoice_ecommon = null;
      this.fiscalData.invoice_special = null;
      this.fiscalData.invoice_especial = null;
      this.fiscalData.invoice_common_rate = null;
      this.fiscalData.invoice_ecommon_rate = null;
      this.fiscalData.invoice_special_rate = null;
      this.fiscalData.invoice_especial_rate = null;
      this.fiscalData.cre_code = "";
      this.fiscalData.trade = "";
      this.fiscalData.reg_cap = "";
      this.fiscalData.company_types = "";
      this.fiscalData.fromTime = "";
      this.fiscalData.toTime = "";
      this.fiscalData.bus_scope = "";
      this.fiscalData.isMicroEnt = "";
      this.addBank.cid = null;
      this.addBank.bank = "";
      this.addBank.accnumber = "";
      this.addBank.bank_type = "";
      this.activeName = "first";
      this.companys = [];
    },
    clearSearchDatas() {
      this.searchArr.company_id = "";
      this.searchArr.start_time = null;
      this.searchArr.end_time = null;
      this.searchArr.start_time_null = false;
      this.searchArr.end_time_null = false;
      this.searchArr.finance_user = "";
      this.searchArr.saler_id = "";
      this.searchArr.leader_id = "";
      this.searchArr.acc_id = "";
      this.searchArr.ass_id = "";
      this.searchArr.advisory_id = "";
      this.searchArr.invoice_id = "";
      this.searchArr.service_advisor_id = "";
      this.searchArr.general_accounting_id = "";
      this.searchArr.area_park = [];
      this.searchArr.order_combo = "";
      this.searchArr.is_ukey = "";
      this.searchArr.is_invoice_bill = "";
      this.searchArr.license_auth = "";
      this.searchArr.triple_agreement = "";
      this.searchArr.social_security = "";
      this.searchArr.accumula_fund = "";
      this.searchArr.manage_forms = "";
      this.searchArr.server_status = "";
      // this.searchArr.invoice_company = "";
      this.searchArr.open_account = "";
      this.searchArr.tax_scale = "";
      this.searchArr.is_bind = "";
      this.searchArr.is_subscribe = "";
      this.searchArr.server_end = "";
      this.searchArr.wx_work_bind = "";
      this.searchArr.archives = "";
      this.searchArr.provinces_code = "";
      this.searchArr.city_code = "";
      this.searchArr.area_code = "";
      this.searchArr.login_way = "";
      this.searchArr.taxNumber = "";
      this.searchArr.my_electronic_password = "";
      this.searchArr.login_identity = "";
      this.searchArr.login_account = "";
      this.searchArr.login_password = "";
      this.searchArr.ca_password = "";
      this.searchArr.natural_identity = "";
      this.searchArr.natural_password = "";
      this.searchArr.digital_certificate_password = "";
      this.searchArr.digital_identity = "";
      this.searchArr.digital_account = "";
      this.searchArr.digital_password = "";
      this.searchArr.income_tax_way = "";
      this.searchArr.income_tax_password = "";
      this.searchArr.income_real_account = "";
      this.searchArr.income_real_password = "";
      this.searchArr.social_account = "";
      this.searchArr.social_password = "";
    },
    clearChatsData() {
      this.chatId = "";
      this.chatDrawer = false;
      this.companyId = null;
      this.chatCompany = "";
    },
    clearChangeData() {
      this.addChangeData.company_id = "";
      this.addChangeData.bussin_content = [];
      this.addChangeData.uid = "";
      this.addChangeData.urgency = 1;
      this.addChangeData.remark = "";
    },
    clearSuggestAdd() {
      this.suggestData.company_id = "";
      this.suggestData.start_time = "";
      this.suggestData.end_time = "";
      this.suggestData.current_combo = "";
      this.suggestData.current_item = [];
      this.suggestData.suggest_content = "";
      this.suggestData.id = null;
    },
    clearRenewData() {
      this.renewData.id = null;
      this.renewData.company_id = "";
      this.renewData.order_id = "";
      this.renewData.start_time = "";
      this.renewData.end_time = "";
    },
    clearChangeSuggest() {
      this.clearChangeData();
      this.clearSuggestAdd();
      this.clearRenewData();
      this.activeConName = "first";
      this.continueDrawer = false;
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.searchOrders(query);
        }, 200);
      } else {
        this.orderNums = [];
      }
    },
    searchOrders(query) {
      this.$axios.get("/api/admin/searchOrders?num=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.orderNums = data.data.orderNum;
        }
      });
    },
    remoteCompanyMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.searchCompanys(query);
        }, 200);
      } else {
        this.companies = [];
      }
    },
    searchCompanys(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.companies = data.data.companies;
        }
      });
    },
    handleSaveRoughly() {
      if (!this.addRoughly) {
        this.$message.error("请填写发票号段");
        return;
      }
      this.$axios
        .post("/api/finance/set_roughly/" + this.upData.fid, {
          roughly: this.addRoughly,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            this.addRoughly = "";
            this.addVisible = false;
            this.upData.invoice_roughly = data.data.roughly.invoice_roughly;
            this.upData.roughly_arr.unshift(data.data.roughly);
            this.finances[this.upData.index].fin_table.fin_roughly.unshift(
              data.data.roughly
            );
            this.records.unshift(data.data.record);
          }
        });
    },
    handCallLogsOpen(row) {
      this.callLogsDrawer = true;
      setTimeout(() => {
        this.company = row.company_name;
        if (row.user) this.callPhone.push(row.user.phone);
        if (row.docking_phone) this.callPhone3.push(row.docking_phone);
        if (row.tyc_orders.length > 0) {
          for (var i = 0; i < row.tyc_orders.length; i++) {
            if (
              row.tyc_orders[i].customer_phone &&
              this.callPhone1.indexOf(row.tyc_orders[i].customer_phone) === -1
            ) {
              this.callPhone1.push(row.tyc_orders[i].customer_phone);
            }
            if (
              row.tyc_orders[i].corporate_phone &&
              this.callPhone2.indexOf(row.tyc_orders[i].corporate_phone) === -1
            ) {
              this.callPhone2.push(row.tyc_orders[i].corporate_phone);
            }
          }
        }
      });
    },
    handleCallLogsBeforeClose(done) {
      this.company = "";
      this.callPhone = [];
      this.callPhone1 = [];
      this.callPhone2 = [];
      this.callPhone3 = [];
      done();
    },
    handleOrderInfo(orderId) {
      this.orderInfoVisible = true;
      setTimeout(() => {
        this.orderInfoId = orderId;
      }, 100);
    },
    handleSetTaxDetail() {
      if (!this.upData.added_set) {
        this.$message.error("请选择增值税周期");
        return;
      }
      if (!this.upData.addtional_set) {
        this.$message.error("请选择附加税周期");
        return;
      }
      if (!this.upData.person_set) {
        this.$message.error("请选择个人所得税周期");
        return;
      }
      if (!this.upData.bussin_tax_set) {
        this.$message.error("请选择生产经营个税周期");
        return;
      }
      if (!this.upData.company_set) {
        this.$message.error("请选择企业所得税周期");
        return;
      }
      if (!this.upData.stamp_set) {
        this.$message.error("请选择印花税周期");
        return;
      }
      if (!this.upData.house_set) {
        this.$message.error("请选择房产税周期");
        return;
      }
      if (!this.upData.finance_set) {
        this.$message.error("请选择财务报表周期");
        return;
      }
      this.$axios
        .post("/api/finance/set_tax", {
          cid: this.upData.company_id,
          added_set: this.upData.added_set,
          addtional_set: this.upData.addtional_set,
          person_set: this.upData.person_set,
          bussin_tax_set: this.upData.bussin_tax_set,
          company_set: this.upData.company_set,
          stamp_set: this.upData.stamp_set,
          house_set: this.upData.house_set,
          finance_set: this.upData.finance_set,
        })
        .then((res) => {
          const { data } = res;
          this.$message.success(data.msg);
        });
    },
    handleLicensePreview(file) {},
    handleLicenseChange(file, fileList) {
      this.licenseList = fileList;
    },
    handleLicenseRemove(file, fileList) {
      this.licenseList = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    handleParse(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList.length < 2) {
            that.licenseList.push(fileObj);
          } else {
            that.$message.error("最多可以上传2张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    submitAddUpload() {
      if (this.licenseList.length === 0) {
        this.$message.error("请上传法人身份证图片");
        return;
      }
      this.formData = new FormData();
      this.licenseList.forEach((file) => this.formData.append("file[]", file.raw));
      this.$axios
        .post("/api/finance/idcard_upload/" + this.upData.fid, this.formData)
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.upData.idcard_img = data.data;
            this.$message.success(data.msg);
            this.formData = null;
            this.licenseList = [];
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    getCheckTaxCateName(checkTaxCate) {
      if (checkTaxCate.length > 0) {
        let strings = "";
        for (let key in this.tax_cates) {
          if (checkTaxCate.indexOf(this.tax_cates[key].id) !== -1) {
            strings += this.tax_cates[key].name + ",";
          }
        }
        return strings.slice(0, strings.length - 1);
      }
    },
    getStaffIsServer(arr) {
      let on = 0;
      let leave = 0;
      if (arr.length > 0) {
        for (let key in arr) {
          if (arr[key].is_inservice === 1) {
            on += 1;
          } else {
            leave += 1;
          }
        }
      }
      return "在职员工" + on + "位，离职员工" + leave + "位";
    },
    fhandleCompanyInfoOpen(cid) {
      this.companyInfoDrawer = true;
      setTimeout(() => {
        this.companyInfoId = cid;
      });
    },
    handleCompanyInfoBeforeClose(done) {
      this.companyInfoId = null;
      done();
    },
    clearAddServerData() {
      this.addServerDrawer = false;
      this.addServer.cid = null;
      this.addServer.leader_id = null;
      this.addServer.acc_id = null;
      this.addServer.ass_id = null;
      this.addServer.advisory_id = null;
      this.addServer.invoice_id = null;
      this.addServer.service_advisor_id = null;
      this.addServer.general_accounting_id = null;
      this.addServer.index = null;
      this.addServer.server_time = [];
      this.addServer.tax_type = "";
      this.addServer.other_server = [];
      this.addServer.take_money_rule = "";
    },
    handleAddServerBeforeClose(done) {
      this.addServerDrawer = false;
      this.addServer.cid = null;
      this.addServer.leader_id = null;
      this.addServer.acc_id = null;
      this.addServer.ass_id = null;
      this.addServer.advisory_id = null;
      this.addServer.invoice_id = null;
      this.addServer.service_advisor_id = null;
      this.addServer.general_accounting_id = null;
      this.addServer.index = null;
      this.addServer.server_time = [];
      this.addServer.tax_type = "";
      this.addServer.other_server = [];
      this.addServer.take_money_rule = "";
      done();
    },
    handleEditServerBeforeClose(done) {
      // this.addServerDrawer = false
      // this.addServer.cid = null
      // this.addServer.leader_id = null
      // this.addServer.acc_id = null
      // this.addServer.ass_id = null
      // this.addServer.advisory_id = null
      // this.addServer.invoice_id = null
      // this.addServer.index = null
      // this.addServer.server_time = []
      // this.addServer.tax_type = ''
      // this.addServer.other_server = []
      // this.addServer.take_money_rule = ''
      done();
    },
    handleOrderInfoClose(done) {
      this.orderInfoId = null;
      done();
    },
    serviceEventState(state) {
      if (state === true) {
        this.serviceEvent = true;
      } else {
        this.serviceEvent = false;
      }
    },
    serviceThingsState(state) {
      if (state === true) {
        this.serviceThings = true;
      } else {
        this.serviceThings = false;
      }
    },
    serviceAccountState(state) {
      if (state === true) {
        this.serviceAccount = true;
      } else {
        this.serviceAccount = false;
      }
    },
    showExample() {
      this.loadExamplePicture();
      this.showExampleDialog = true;
    },
    loadExamplePicture() {
      this.$axios
        .get("api/finance/get_example")
        .then(({ data }) => {
          if (data.code === 200) {
            this.example_url = data.data.url;
          }
        })
        .catch();
    },
    filterOptions(node, keyword) {
      return filterKeywordOptions(node, keyword);
    },
    closeShowExampleDialog() {
      this.example_url = "";
    },
    handleOtherService() {
      this.SelectedValueAddedOptions = [];
      var arr = [];
      //   if (n.length > 0) {
      this.valueAddedOptions.map((item) => {
        this.addServer.other_server.map((i) => {
          if (item.id === i) {
            arr.push(item);
          }
        });
      });
      //   }
      this.SelectedValueAddedOptions = arr;
    },
  },
  watch: {
    "addServer.other_server": {
      handler(n) {
        this.SelectedValueAddedOptions = [];
        var earr = [];
        if (n.length > 0) {
          this.valueAddedOptions.map((item) => {
            this.addServer.other_server.map((i) => {
              if (item.id == i) {
                earr.push(item);
              }
            });
          });
        }
        this.SelectedValueAddedOptions = earr;
      },
      deep: true,
    },
    row: {
      handler(n) {
        this.addServer.cid = "";
        this.addServer.leader_id = "";
        this.addServer.acc_id = "";
        this.addServer.ass_id = "";
        this.addServer.advisory_id = "";
        this.addServer.invoice_id = "";
        this.addServer.service_advisor_id = "";
        this.addServer.general_accounting_id = "";
        this.addServer.server_time = [];
        this.addServer.tax_types = "";
        this.addServer.take_money_rule = "";
        this.addServer.take_money_rule_real = [];
        this.addServer.other_server = [];
        this.addServer.begin_time = "";
        this.addServer.is_zero = "";
        this.addServer.share_id = "";
        this.addServer.proxy_software = "";
        this.addServer.include_gifts = false;
        this.addServer.gifts_length = "";
        if (n) {
          var editData = JSON.stringify(n);
          editData = JSON.parse(editData);
          this.addServer.cid = editData.id;
          this.addServer.leader_id = editData.com_fiscal_tax.leader_id;
          this.addServer.acc_id = editData.com_fiscal_tax.acc_id;
          this.addServer.ass_id = editData.com_fiscal_tax.ass_id;
          this.addServer.advisory_id = editData.com_fiscal_tax.advisory_id;
          this.addServer.invoice_id = editData.com_fiscal_tax.invoice_id;
          this.addServer.service_advisor_id = editData.com_fiscal_tax.service_advisor_id;
          // this.addServer.general_accounting_id = editData.com_fiscal_tax.general_accounting_id;
          if (editData.fin_table) {
            if (editData.fin_table.start_time && editData.fin_table.end_time) {
              this.addServer.server_time = [
                editData.fin_table.start_time,
                editData.fin_table.end_time,
              ];
            }
            if (editData.fin_table.other_server) {
              var arr = editData.fin_table.other_server.map((item) => {
                return Number(item);
              });
              arr = arr.filter((item) => {
                return item !== 0;
              });
              if (arr.length > 0) {
                this.addServer.other_server = arr;
              }
            }
            this.addServer.begin_time = editData.fin_table.begin_time;
            this.addServer.include_gifts =
              editData.fin_table.include_gifts == 1 ? true : false;
            this.addServer.gifts_length = editData.fin_table.gifts_length;
          }
          this.addServer.tax_types = editData.com_fiscal_tax.tax_types + "";
          this.addServer.take_money_rule = editData.com_fiscal_tax.fin_charges;

          this.addServer.is_zero = editData.com_fiscal_tax.is_zero_declare;
          if (editData.real_price) {
            editData.real_price.map((item) => {
              this.addServer.take_money_rule_real[item.value_id] = item.price;
            });
          }
          // 共享人
          if (editData.shares) {
            this.addServer.share_id = [];
            editData.shares.map((item) => {
              this.addServer.share_id.push(item.adminuser_id);
            });
          }
          if (editData.leader) {
            this.addServer.leader_id = [];
            editData.leader.map((item) => {
              this.addServer.leader_id.push(item.adminuser_id);
            });
          }
          if (editData.acc) {
            this.addServer.acc_id = [];
            editData.acc.map((item) => {
              this.addServer.acc_id.push(item.adminuser_id);
            });
          }
          if (editData.ass) {
            this.addServer.ass_id = [];
            editData.ass.map((item) => {
              this.addServer.ass_id.push(item.adminuser_id);
            });
          }
          if (editData.advisory) {
            this.addServer.advisory_id = [];
            editData.advisory.map((item) => {
              this.addServer.advisory_id.push(item.adminuser_id);
            });
          }
          if (editData.invoice) {
            this.addServer.invoice_id = [];
            editData.invoice.map((item) => {
              this.addServer.invoice_id.push(item.adminuser_id);
            });
          }
          if (editData.service_advisory) {
            this.addServer.service_advisor_id = [];
            editData.service_advisory.map((item) => {
              this.addServer.service_advisor_id.push(item.adminuser_id);
            });
          }
          if (editData.general_account) {
            this.addServer.general_accounting_id = [];
            editData.general_account.map((item) => {
              this.addServer.general_accounting_id.push(item.adminuser_id);
            });
          }
          this.addServer.proxy_software = editData.com_fiscal_tax.software_types
            ? Number(editData.com_fiscal_tax.software_types)
            : "";
        }
      },
      deep: true,
    },
    // row(n) {
    //     if (n) {
    //         var editData = JSON.stringify(n)
    //         editData = JSON.parse(editData)
    //         this.addServer.cid = editData.id
    //         this.addServer.leader_id = editData.com_fiscal_tax.leader_id
    //         this.addServer.acc_id = editData.com_fiscal_tax.acc_id
    //         this.addServer.ass_id = editData.com_fiscal_tax.ass_id
    //         this.addServer.advisory_id = editData.com_fiscal_tax.advisory_id
    //         this.addServer.invoice_id = editData.com_fiscal_tax.invoice_id
    //         this.addServer.server_time = [editData.fin_table.start_time, editData.fin_table.end_time]
    //         this.addServer.tax_type = 2
    //         this.addServer.take_money_rule = editData.com_fiscal_tax.fin_charges
    //         var arr = editData.fin_table.other_server.map(item => {
    //             return Number(item)
    //         })
    //         var arr = arr.filter(item => {
    //             return item !== 0
    //         })
    //         if (arr.length > 0) {
    //             this.addServer.other_server = arr
    //         }
    //         this.addServer.begin_time = editData.fin_table.begin_time
    //         this.addServer.is_zero = editData.fin_table.is_zero
    //     }
    // }
  },
  mounted() {
    this.getValueAdded();
    this.getFinanceData();
  },
};
</script>
<style scoped>
[v-cloak] {
  display: none;
}

#value-add-table td {
  font-size: medium;
  line-height: 0.5rem;
}

.options-first {
  margin-top: 0.05rem;
}

.options-second {
  margin-top: 0.05rem;
  margin-left: 0.4rem;
}

.finance_table_div {
  /* margin-left: 1.25rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

a {
  background: transparent;
  color: #108ee9;
  cursor: pointer;
  outline: none;
  text-decoration: none;
  transition: color 0.3s ease;
}

.el-col-3 {
  margin-right: 10px;
}

.text {
  font-size: 14px;
}

.items {
  margin-bottom: 18px;
}

.m-tabs-content >>> .el-form-item__label {
  width: 190px !important;
}

.m-tabs-content >>> .el-form-item__content {
  margin-left: 200px !important;
}

.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}

.el-collapse {
  border-bottom: 0;
  border-top: 0;
}

.el-collapse >>> .el-collapse-item__header {
  color: #4c87fc;
  font-weight: bold;
}

.el-collapse >>> .el-collapse-item__arrow {
  color: #4c87fc;
}

.el-select {
  width: 100%;
}

.finance_table_div >>> .el-table__header th {
  color: #333333;
  background-color: #ecf4ff;
}

.finance_table_div .count_style {
  display: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tr {
  text-align: right;
}

.mt-10 {
  margin-top: 0.2rem;
}

.m-tabs-content {
  padding: 0 0.2rem 0 0.4rem;
}

.m-tabs-content .m-label {
  line-height: 0.64rem;
}

.m-tabs-content .el-row {
  margin-bottom: 0.4rem;
}

.el-date-editor {
  width: 100%;
}

.top-line {
  color: #409eff;
  font-weight: bold;
  margin: 0 0 0 0;
}

.messages-list {
  min-height: calc(100vh - 210px);
  height: 6rem;
  overflow-y: auto;
}

.messages-list .messages-con {
  padding: 0.4rem;
}

.messages-list .messages-con .message {
  padding: 0.2rem;
}

.messages-list .messages-con .image_con {
  padding: 0.2rem;
}

.messages-list .infinite-item-content {
  display: inline-block;
  margin-top: 0.2rem;
  padding: 0 0.36rem 0 0.36rem;
  line-height: 0.9rem;
  background-color: #eef0f5;
}

.messages-list .popper__arrow {
  position: absolute;
  top: 0.04rem;
  left: 0.36rem;
  display: block;
  margin-right: 0.06rem;
  border-color: transparent;
  border-style: solid;
  border-width: 0.18rem;
  border-top-width: 0;
  border-bottom-color: #eef0f5;
  filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));
}

.top_hint {
  height: 0.8rem;
  line-height: 0.8rem;
  background: #ecf4ff;
}

.top_hint span {
  color: #5787ff;
}
</style>



// WEBPACK FOOTER //
// src/pages/finance_register/ServiceEdit.vue